<template xmlns="http://www.w3.org/1999/html">
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'company.assignments.list' }">
                {{ $t('menu.company_dashboard.assignments') }}
              </router-link>
            </li>
            <li>{{ $t('menu.company_dashboard.create_assignment') }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left"><span>{{ $t('general.new_assignment') }}</span></h2>
        </div>
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <ul id="main-switcher" class="uk-child-width-expand uk-tab stepper-buttons"
          uk-switcher="connect: #main-switcher-tabs ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
          <li class="uk-active">
            <a class=" p-4 header-a" href="#"><i class="icon-feather-flag"></i> <b>{{ $t('login.header') }}</b></a>
          </li>
          <li>
            <a class="p-4 header-a" href="#"><i class="uil-book-open"></i> <b>{{ $t('messages.content') }}</b></a>
          </li>
          <li>
            <a class="p-4 header-a" href="#"><i class="uil-users-alt"></i> <b>{{ $t('users.users') }}</b></a>
          </li>
          <li v-if="$isGiftVisible">
            <a class="p-4  header-a" href="#"><i class="uil-gift"></i> <b>{{ $t('general.gift') }}</b></a>
          </li>
          <li>
            <a class="p-4 header-a" href="#" @click="hideSomeInputsForClassRoomEducation"><i class="uil-cog"></i>
              <b>{{ $t('general.settings') }}</b></a>
          </li>
          <li>
            <a class="p-4 header-a" href="#"><i class="uil-invoice"></i> <b>{{ $t('general.overview') }}</b></a>
          </li>
        </ul>
        <default-loading v-show="assignment_loading"></default-loading>
        <div v-show="!assignment_loading">
          <div class="card-body">
            <ul id="main-switcher-tabs" class="uk-switcher uk-margin">
              <!--tab: özellikler-->
              <li>
                <div class="row">
                  <div class="col-xl-9 m-auto">
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="course_title">{{
                        $t('general.assignment_name')
                      }}<span class="required">*</span></label>
                      <div class="col-md-9">
                        <input id="course_title" v-model="name" class="form-control" required="" type="text" />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="short_description">{{
                        $t('collectionDetail.content_description')
                      }} <span class="required">*</span><i :uk-tooltip="'title: ' + $t('general.description-max-1000')"
                          class="uil-info-circle ml-1"></i>
                        <br />({{ textarea_length }} / 1000)
                      </label>
                      <div class="col-md-9">
                        <textarea id="short_description" v-model="description" class="form-control" maxlength="1000"
                          name="short_description"></textarea>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label">{{
                        $t("general.instructors")
                      }}</label>
                      <div class="col-md-9">
                        <app-multiselect
                          v-model="selectedInstructors"
                          :allow-empty="true"
                          :close-on-select="false"
                          :is-disabled="instructorsLoading"
                          :is-multiple="true"
                          :options="instructorOptions"
                          label="name"
                          :placeholder="$t('general.select_instructor')"
                          track-by="id"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="logo">{{
                        $t('collectionDetail.cover_image')
                      }}<span class="required">*</span></label>
                      <div class="col-md-9">
                        <div uk-alert>
                          <a class="uk-alert-close" uk-close></a>
                          <h5><i class="uil-comment-info-alt"></i> {{ $t('general.information') }}</h5>
                          <p v-html="$t('general.catalog_cover_image_info', {
                            formats: '<b>.jpg, .png, .gif</b>',
                            dimensions: '<b>521x288</b>'
                          })"></p>
                        </div>
                        <div class="position-relative d-flex justify-center justify-content-center">
                          <img :src="getImageUrl()" alt="" class="rounded img-fluid logoarea" style="height: 190px" />
                          <input id="cover_photo_input" accept="image/jpeg, image/jpg, image/png, image/gif"
                            class="d-none" type="file" @change="processFile($event)" />
                          <button class="btn btn-default btn-icon-label" style="top: 50%; position: absolute"
                            type="button" @click="inputClick()">
                            <span class="btn-inner--icon">
                              <i class="uil-image" />
                            </span>
                            <span class="btn-inner--text">{{ $t("general.image_change") }}</span>
                          </button>
                        </div>
                        <ai-cover-image-generator
                            :max-size-mb="15"
                            file-prefix="ai-assignment-cover"
                            @image-selected="handleAiCoverImageSelected"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0 mb-3">
                  <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(1)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </li>
              <!--tab: eğitim-->
              <li>
                <div class="row">
                  <div class="col-md-12">
                    <div v-if="showModalLearning" id="modal_learning" class="uk-modal-full uk-modal" uk-modal="">
                      <div class="uk-modal-footer bggray">
                        <h3 class="float-left">
                          <i class="uil-presentation-plus"></i> {{ $t('general.select_content') }}
                        </h3>
                        <button class="uk-button uk-button-default small uk-modal-close  float-right" type="button">
                          <i class="uil-times"></i> {{ $t("general.close") }}
                        </button>
                      </div>

                      <div class="uk-modal-dialog bggray h-100">
                        <Content :selected_items="all_selected_educations" :show_exam="true" :show_program="true"
                          :show_survey="true" :with_competencies="true" @addNewEducation="addContentToAssignment($event)"
                          @removeEducation="removeContentFromAssignment($event)" />
                      </div>
                    </div>

                    <div class="mb-2 mx-2 bggray px-2 pt-2 pb-3 card">
                      <div class="row text-right">
                        <div class="col-md-10">
                          <div class="row" style="display:flex;justify-content:end">
                            <label class="col-md-3 col-form-label">
                              {{ $t('general.sequential-content') }}
                            </label>
                            <div class="col-md-1">
                              <label class="uk-switch" for="can_open_contents_in_order">
                                <input id="can_open_contents_in_order" v-model="can_open_contents_in_order"
                                  type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <button class="btn btn-info btn-sm mb-3" uk-toggle="target: #modal_learning">
                            <i class="uil-plus m-0"></i> {{ $t('general.select_content') }}
                            <span class="required">*</span>
                          </button>
                        </div>
                      </div>
                      <div v-if="!educations || educations.length == 0" class="text-center mb-3">
                        {{ $t('general.no-content-selected') }}
                      </div>
                      <draggable v-else :list="educations" class="uk-accordion-content mt-0" group="education_widget">
                        <div v-for="(education, index) in educations" :key="'assignment_content_list_' + index">
                          <div class="sec-list-item">
                            <div>
                              <i class="uil-list-ul mr-2"></i>
                              <p>{{ education.title }}</p>
                              <label class="mb-0 mx-2" style="
                                                      font-size: 0.75rem;
                                                      background: #3e416d;
                                                      padding: 1px 5px;
                                                      border-radius: 3px;
                                                      color: white;
                                                    ">{{ $t(education.name) }}</label>
                            </div>

                            <div>
                              <div class="btn-act">
                                <!-- <a href="#" uk-tooltip="title:Önizleme"
                                  ><i class="uil-eye"></i
                                ></a> -->

                                <span v-if="education.competencies?.length > 0"
                                  :class="{ 'strikethrough': is_competency_selected }"
                                  :uk-tooltip="getCompetencyTooltip(education.competencies)"
                                  class="uk-label uk-background-muted uk-text-muted">
                                  <i class="uil-plus"></i> {{ $t('general.competencies_to_be_acquired') }}
                                </span>

                                <a @click="showCustomize(education.id, index)">
                                  <i class="icon-feather-settings" style="margin-right: 2px;"></i>
                                  {{ $t('general.customize') }}</a>
                                <a :uk-tooltip="'title: ' + $t('general.deselect')" href="#"
                                  @click.prevent="removeContentFromAssignment(education, index)">
                                  <i class="icon-feather-trash"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </draggable>

                    </div>

                    <hr>
                    <div class="row mb-2">
                      <div class="col-md-4 d-flex align-items-center">
                        <div class="row">
                          <div class="col-md-2">
                            <label class="uk-switch" for="assigned_competencies">
                              <input id="assigned_competencies" v-model="is_competency_selected" class="mr-2"
                                type="checkbox" uk-toggle="target: #assigned_competencies_list" />
                              <div class="uk-switch-slider"></div>
                            </label>
                          </div>
                          <label class="col-form-label col-md-9 pt-0 ml-2" for="assigned_competencies">
                            {{ $t('general.when_assignment_completed_competence_be_gained') }}
                            <i :uk-tooltip="'title: ' + $t('general.competency-info')" class="uil-info-circle"></i>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div id="assigned_competencies_list" class="mb-2 mx-2 bggray p-4 card" hidden>
                          <div class="row">
                            <div class="col-md-12">
                              <label for=""><i class="uil-star"></i>
                                {{ $t('general.competencies_to_be_acquired') }}</label>
                              <CompetenciesInputSelection v-model="selectedCompetencies" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="uk-card-footer float-right pb-0 pr-0">
                      <button class="uk-button uk-button-outline small mr-2" type="button" @click="switcherChange(0)">
                        <i class="icon-feather-arrow-left"></i>{{ $t("general.previous") }}
                      </button>
                      <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(2)">
                        <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                      </button>
                    </div>
                  </div>
                </div>
              </li>
              <!--tab: kullanıcılar-->
              <li>
                <UserGroupSelection :checked_groups="checked_groups" :checked_users="checked_users"
                  :is-user-list-included="true" @setCheckedGroups="($event) => { checked_groups = $event }"
                  @setCheckedUsers="($event) => { checked_users = $event }" />

                <div class="uk-card-footer float-right pb-0 pr-0 mb-3">
                  <button class="uk-button uk-button-outline small mr-2" type="button" @click="switcherChange(1)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small" type="button" @click="validateAndSwitch(3)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </li>
              <!--tab: hediye-->
              <li v-if="$isGiftVisible">
                <div class="row">
                  <div class="col-md-3">
                    <div id="gift-mode" class="btn-night-mode">
                      <i class="icon-feather-gift"></i> {{ $t('general.give_a_gift_at_the_end') }}
                      <span class="btn-night-mode-switch">
                        <label class="uk-switch" for="default-1">
                          <input id="default-1" v-model="has_present" type="checkbox" />
                          <div class="uk-switch-slider"></div>
                        </label>
                      </span>
                    </div>
                    <div v-if="has_present" class="form-group row mt-3">
                      <div class="col-md-12">
                        <label class="col-form-label" for="course_title">
                          {{ $t('general.rule_for_earning_gift') }}<span class="required">*</span></label>
                        <select v-model="gift_rule_id" class="selectpicker7">
                          <option value="1">{{ $t('general.fastest_to_complete') }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-if="has_present" class="col-md-9">
                    <div class="uk-accordion-content mt-0">
                      <div id="modal_gifts" class="uk-modal-full uk-modal" uk-modal="">
                        <div class="uk-modal-footer bggray">
                          <h3 class="float-left">
                            <i class="uil-presentation-plus"></i>
                            {{ $t("gift.management") }}
                          </h3>
                          <button class="
                                            uk-button uk-button-default
                                            small
                                            uk-modal-close
                                            float-right
                                          " type="button">
                            <i class="uil-times"></i> {{ $t("general.close") }}
                          </button>
                        </div>

                        <div class="uk-modal-dialog bggray h-100">
                          <Gift :selected_items="all_selected_gifts" @addNewGift="addGiftToAssignment($event)"></Gift>
                        </div>
                      </div>
                      <ul class="sec-list gift">
                        <button class="btn btn-secondary mb-3 w-100" uk-toggle="target: #modal_gifts">
                          <i class="uil-plus m-0"></i> {{ $t('general.add_gift') }}<span class="required">*</span>
                        </button>
                        <draggable :list="gifts" group="gifts_widget">
                          <li v-for="(item, index) in gifts">
                            <div class="sec-list-item" style="cursor: move">
                              <div>
                                <img :src="item.image" alt="" />
                                <p>{{ item.name }}</p>
                                <span style="
                                                  display: block;
                                                  font-size: 0.875rem;
                                                  color: #ae71ff;
                                                  margin-left: 0.4rem;
                                                ">(<i class="uil-user d-inline"></i>
                                  {{ index + 1 }}. {{ $t('general.winner') }})</span>
                              </div>
                              <div>
                                <div class="btn-act">
                                  <a href="#" @click.prevent="removeGiftFromAssignment(item.id)
                                    "><i class="icon-feather-x"></i></a>
                                </div>
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0 pr-0 mb-3">
                  <button class="uk-button uk-button-outline small mr-2" type="submit" @click="switcherChange(2)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small" type="submit" @click="validateAndSwitch(4)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </li>
              <!--tab: ayarlar-->
              <li>
                <div class="container">
                  <div class="row">
                    <div class="col-md-3">
                      <ul class="uk-tab-right uk-tab sidemenu"
                        uk-switcher="connect: #settings-tab ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
                        <li class="uk-active">
                          <a href="#"><i class="uil-keyboard"></i>
                            <b>{{ $t('general.assignment_settings') }}</b></a>
                        </li>
                        <li>
                          <a href="#"><i class="uil-envelope-edit"></i>
                            <b>{{ $t('general.message_settings') }} </b></a>
                        </li>
                      </ul>
                    </div>

                    <div class="col-md-9">
                      <ul id="settings-tab" class="uk-switcher">
                        <li class="uk-active">
                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="course_title">
                              {{ $t('general.program_option') }}<span class="required">*</span></label>
                            <div class="col-md-6">
                              <select v-model="is_compulsory">
                                <option :value="true"> {{ $t('assignment.compulsory') }}</option>
                                <option :value="false"> {{ $t('assignment.not_compulsory') }}</option>
                              </select>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.certificate_selection') }}
                              <i :uk-tooltip="'title: ' + $t('general.certificate-info')"
                                class="uil-info-circle"></i></label>
                            <div class="col-md-6">
                              <multiselect v-model="certificate" :allow-empty="true" :options="certificate_items"
                                :placeholder="$t('general.select_certificate')" :searchable="true"
                                :tag-placeholder="$t('general.select_certificate')" deselectLabel="" label="name"
                                :selectLabel="$t('general.select')" track-by="id" />
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label">
                              {{ $t('general.menu_selection') }}
                            </label>
                            <div class="col-md-6">
                              <multiselect v-model="selectedWidgets" :allow-empty="true" :options="widgetItems"
                                :multiple="true" :placeholder="$t('general.choose')" :searchable="true" deselectLabel=""
                                label="title" :selectLabel="$t('general.select')" track-by="id" />
                            </div>
                          </div>

                          <hr />

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.feature_the_training') }}
                              <i :uk-tooltip="'title: ' + $t('general.feature-the-training-info')"
                                class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="default-one-cikanlar">
                                <input id="default-one-cikanlar" v-model="highlight_education" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="mandatory_completion">
                              {{ $t('general.show-on-system-start') }}
                              <i :uk-tooltip="'title: ' + $t('general.mandatory-assignment-info')"
                                class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="mandatory_completion">
                                <input id="mandatory_completion" v-model="mandatory_completion" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <hr />

                          <div class="form-group row mb-2 input-checkbox">
                            <DateRangePicker :end-date.sync="end_date" :end-label="$t('general.final_completion_date')"
                              :end-tooltip="$t('general.end-date-info')" :min-start-date="setMinimumDate()"
                              :required="true" :start-date.sync="start_date" :start-label="$t('general.start_day')"
                              :start-tooltip="$t('general.start-date-info')" />

                            <div class="col-md-12">
                              <div v-if="!isClassRoomEducationSelected" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="website_keywords">{{
                                  $t('general.repetition')
                                }}
                                  <i :uk-tooltip="'title: ' + $t('general.repeatable-info')" class="uil-info-circle">
                                  </i>
                                </label>
                                <div class="col-md-6">
                                  <label class="uk-switch" for="repeatable">
                                    <input id="repeatable" v-model="repeatable" type="checkbox" />
                                    <div class="uk-switch-slider"></div>
                                  </label>
                                </div>
                              </div>
                              <div v-if="repeatable" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="website_keywords">
                                  {{ $t('general.number_of_repetitions') }}
                                  <span class="required">*</span>
                                  <i class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <input v-model="repetition_no" class="form-control" min="0" style="width: 100px"
                                    type="number" @keypress="isNumber($event)" />
                                </div>
                              </div>

                              <template v-if="repetition_no && repeatable">
                                <hr />
                                <template v-for="i in parseInt(repetition_no)">
                                  <div v-if="'row_key' + i" :key="'row_key' + i" class="row w-100 mb-3">
                                    <div :key="'row_number_' + i"
                                      class="col-md-2 d-flex align-items-end justify-content-center">
                                      <span class="row_number">{{ i }}.</span>
                                    </div>
                                    <div :key="'start_date_index_' + i" class="col-md-5">
                                      <label class="col-form-label" for="pass">{{ $t('general.start_day') }}<span
                                          class="required">*</span>
                                      </label>
                                      <input v-if="repetition_date[i]" id="pass" v-model="repetition_date[i].start_date"
                                        :min="setMinimumDate()" class="form-control mb-0" type="date" />
                                    </div>
                                    <div :key="'end_date_index_' + i" class="col-md-5">
                                      <label class="col-form-label" for="pass">
                                        {{ $t('general.final_completion_date') }}<span class="required">*</span>
                                      </label>
                                      <input v-if="repetition_date[i]" id="pass" v-model="repetition_date[i].end_date"
                                        :min="repetition_date[i].start_date
                                          ? setMinimumDate(
                                            repetition_date[i].start_date
                                          )
                                          : setMinimumDate()
                                          " class="form-control mb-0" type="date" />
                                    </div>
                                  </div>
                                </template>
                                <hr />
                              </template>

                              <div class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="following_assignment">
                                  {{ $t('general.next-assignment') }}
                                  <i :uk-tooltip="'title: ' + $t('general.next-assignment-info')"
                                    class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <multiselect v-model="following_assignment_id" :allow-empty="true"
                                    :clear-on-select="false" :deselectLabel="$t('general.deselect')" :max-height="600"
                                    :multiple="false" :options="assignmentsList" :placeholder="$t('general.select')"
                                    :preserve-search="true" :searchable="true" :selectLabel="$t('general.select')"
                                    :selectedLabel="$t('general.selected')" :tag-placeholder="$t('general.select')"
                                    label="name" track-by="id" />
                                </div>
                              </div>
                              <div v-if="following_assignment_id" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="assign_after_days">
                                  {{ $t('general.assign-after-days') }}
                                  <span class="required">*</span>
                                  <i :uk-tooltip="'title: ' + $t('general.assign-after-days-info')"
                                    class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <multiselect v-if="!showCustomDayInput" v-model="assign_after_days" :allow-empty="false"
                                    :clear-on-select="false" :deselectLabel="$t('general.deselect')" :max-height="600"
                                    :multiple="false" :options="[
                                      { value: 365, label: $t('general.365-days-later') },
                                      { value: 180, label: $t('general.180-days-later') },
                                      { value: 90, label: $t('general.90-days-later') },
                                      { value: 15, label: $t('general.15-days-later') },
                                      { value: 'custom', label: $t('general.other') }
                                    ]" :placeholder="$t('general.select')" :preserve-search="false" :searchable="false"
                                    :selectLabel="$t('general.select')" :selectedLabel="$t('general.selected')"
                                    :tag-placeholder="$t('general.select')" label="label" track-by="value" />
                                  <div v-if="showCustomDayInput" class="input-group">
                                    <input v-model.number="customDays" :placeholder="$t('general.day-count')"
                                      class="form-control" min="1" type="number" @keypress="isNumber($event)" />
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-secondary" type="button"
                                        @click="showCustomDayInput = false; assign_after_days = null; customDays = null">
                                        <i class="uil-multiply"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <hr />

                          <div v-if="durationFeatureIsEnabled">
                            <div class="form-group domain row mb-2">
                              <label class="col-md-6 col-form-label" for="assigment_duration">
                                {{ $t('general.duration') }} <i class="uil-info-circle"></i>
                              </label>
                              <div class="col-md-6">
                                <div class="d-flex">
                                  <input id="assigment_duration" v-model="duration" class="form-control flex-grow-1"
                                    min="0" type="number" @keypress="isNumber($event)" /><span>{{
                                      $t("general.minutes")
                                    }}</span>
                                </div>
                              </div>
                            </div>
                            <hr />
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="survey_required" style="padding-right:0">{{
                              $t('general.add_survey_after_the_training')
                            }}
                              <i :uk-tooltip="'title: ' + $t('general.survey-info')" class="uil-info-circle"></i></label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="survey_required">
                                <input id="survey_required" v-model="survey_required" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div v-show="survey_required" class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.select_evaluation_survey') }}<span class="required">*</span>
                            </label>
                            <div class="col-md-6">
                              <multiselect v-model="survey_id" :allow-empty="false" :options="survey_items"
                                :placeholder="$t('general.select_a_survey_or_evaluation_form')" :searchable="true"
                                :tag-placeholder="$t('general.select_a_survey_or_evaluation_form')" deselectLabel=""
                                label="name" :selectLabel="$t('general.select')" track-by="id" />
                            </div>
                          </div>
                          <hr />

                          <div v-if="!isClassRoomEducationSelected" class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">{{
                              $t('general.show_the_top_rankings_list')
                            }}
                              <i :uk-tooltip="'title: ' + $t('general.leaderboard-info')" class="uil-info-circle">
                              </i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="appear_top">
                                <input id="appear_top" v-model="appear_top" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="has_feedbacks">
                              {{ $t('general.experience_sharing') }}
                              <i :uk-tooltip="'title: ' + $t('general.experience-sharing-info')"
                                class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="has_feedbacks">
                                <input id="has_feedbacks" v-model="has_feedbacks" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="can_be_watched_again">
                              {{ $t('general.allow_users_to_watch_the_training_again') }}
                              <i :uk-tooltip="'title: ' + $t('general.completed-training-info')"
                                class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="can_be_watched_again">
                                <input id="can_be_watched_again" v-model="can_be_watched_again" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="send_mail_notification">{{
                              $t('general.send_email') }}</label>
                            <div class="col-md-6 text-right">
                              <label class="uk-switch" for="send_mail_notification">
                                <input id="send_mail_notification" v-model="send_mail_notification" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                            <div class="row m-0" v-if="send_mail_notification && !send_mobile_notification"
                              style="width:100%">
                              <div class="col-md-3" style="margin-top: 1rem">
                                {{ $t('general.notification_send_time') }}
                              </div>
                              <div class="col-md-5" style="margin-top: 0.9rem">
                                <div class="d-flex align-items-center" style="gap: 20px;">
                                  <label class="d-flex align-items-center mb-0 cursor-pointer">
                                    <input id="now-radio" type="radio" value="now" v-model="notification_send_type"
                                      class="mr-2" style="margin-top: 0" />
                                    <span for="now-radio"
                                      style="display: inline-block; margin-bottom: 15px; color:#8694a8; cursor: pointer;font-weight: 100;">
                                      {{ $t('general.send_now') }}
                                    </span>
                                  </label>

                                  <label class="d-flex align-items-center mb-0 cursor-pointer">
                                    <input id="scheduled-radio2" type="radio" value="scheduled"
                                      v-model="notification_send_type" class="mr-2" style="margin-top: 0" />
                                    <span class="tooltip-wrap"
                                      style="display: inline-block;margin-bottom: 15px;color: #8694a8;cursor: pointer;font-weight: 100;"
                                      :title="$t('general.notification_date_before_start_info')">
                                      {{ $t('general.scheduled_send') }}
                                      <span class="tooltip-text">
                                        {{ $t('general.notification_date_before_start_info') }}
                                      </span>
                                    </span>

                                  </label>
                                </div>
                              </div>
                              <div v-if="notification_send_type === 'scheduled'" class="col-md-4">
                                <VueCtkDateTimePicker :format="'YYYY-MM-DD HH:mm:ss'" :no-button-now="true"
                                  style="left:-20px!important" v-model="notification_scheduled_at"
                                  :min-date="setMinimumDate()" />
                              </div>

                            </div>
                            <div v-if="send_mail_notification && !send_mobile_notification" class="col-md-12">
                              <p><input id="notification1" v-model="isRemindEntered" class="mr-2" name="notification1"
                                  type="checkbox">{{ $t('general.remind_if_not_entered_prefix') }}
                                <input v-model="remind_if_not_entered_x_days" class="d-inline" max="365" min="1"
                                  name="notification1_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.day_unit') }}
                                {{ $t('general.remind_if_not_entered_mid') }}
                                <input v-model="remind_if_not_entered_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification1_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                              <p>
                                <input id="notification2" v-model="isRemindStarting" class="mr-2" name="notification2"
                                  type="checkbox">{{ $t('general.remind_before_start_prefix') }}
                                <input v-model="remind_before_starting_x_days" class="d-inline" max="365" min="1"
                                  name="notification2_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.days_before') }}
                                {{ $t('general.every') }}
                                <input v-model="remind_before_starting_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification2_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                              <p><input id="notification3" v-model="isRemindEnding" class="mr-2" name="notification3"
                                  type="checkbox">{{ $t('general.remind_before_end_prefix') }}
                                <input v-model="remind_before_ending_x_days" class="d-inline" max="365" min="1"
                                  name="notification2_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.days_before') }}
                                {{ $t('general.every') }}
                                <input v-model="remind_before_ending_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification2_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="send_mobile_notification">{{ $t('general.send_mobile_notification') }}</label>
                            <div class="col-md-6 text-right">
                              <label class="uk-switch" for="send_mobile_notification">
                                <input id="send_mobile_notification" v-model="send_mobile_notification" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                            <div class="row m-0"
                              v-if="send_mobile_notification || (send_mobile_notification && send_mail_notification)"
                              style="width:100%">
                              <div class="col-md-3" style="margin-top: 1rem">
                                {{ $t('general.notification_send_time') }}
                              </div>
                              <div class="col-md-5" style="margin-top: 0.9rem">
                                <div class="d-flex align-items-center" style="gap: 20px;">

                                  <label class="d-flex align-items-center mb-0 cursor-pointer">

                                    <input id="now-radio" type="radio" value="now" v-model="notification_send_type"
                                      class="mr-2" style="margin-top: 0" />

                                    <span for="now-radio"
                                      style="display: inline-block; margin-bottom: 15px; color:#8694a8; cursor: pointer;font-weight: 100;">
                                      {{ $t('general.send_now') }}
                                    </span>

                                  </label>

                                  <label class="d-flex align-items-center mb-0 cursor-pointer">

                                    <input id="scheduled-radio2" type="radio" value="scheduled"
                                      v-model="notification_send_type" class="mr-2" style="margin-top: 0" />

                                    <span class="tooltip-wrap"
                                      style="display: inline-block; margin-bottom: 15px;color: #8694a8;cursor: pointer;font-weight: 100;"
                                      :title="$t('general.notification_date_before_start_info')">
                                      {{ $t('general.scheduled_send') }}

                                      <span class="tooltip-text">
                                        {{ $t('general.notification_date_before_start_info') }}
                                      </span>
                                    </span>

                                  </label>
                                </div>
                              </div>
                              <div v-if="notification_send_type === 'scheduled'" class="col-md-4">
                                <VueCtkDateTimePicker :format="'YYYY-MM-DD HH:mm:ss'" :no-button-now="true"
                                  style="left:-20px!important" v-model="notification_scheduled_at"
                                  :min-date="setMinimumDate()" />
                              </div>

                            </div>
                            <div v-if="send_mobile_notification || (send_mobile_notification && send_mail_notification)"
                              class="col-md-12">
                              <p><input id="notification1" v-model="isRemindEntered" class="mr-2" name="notification1"
                                  type="checkbox">{{ $t('general.remind_if_not_entered_prefix') }}
                                <input v-model="remind_if_not_entered_x_days" class="d-inline" max="365" min="1"
                                  name="notification1_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.day_unit') }}
                                {{ $t('general.remind_if_not_entered_mid') }}
                                <input v-model="remind_if_not_entered_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification1_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                              <p>
                                <input id="notification2" v-model="isRemindStarting" class="mr-2" name="notification2"
                                  type="checkbox">{{ $t('general.remind_before_start_prefix') }}
                                <input v-model="remind_before_starting_x_days" class="d-inline" max="365" min="1"
                                  name="notification2_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.days_before') }}
                                {{ $t('general.every') }}
                                <input v-model="remind_before_starting_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification2_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                              <p><input id="notification3" v-model="isRemindEnding" class="mr-2" name="notification3"
                                  type="checkbox">{{ $t('general.remind_before_end_prefix') }}
                                <input v-model="remind_before_ending_x_days" class="d-inline" max="365" min="1"
                                  name="notification2_day1" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.days_before') }}
                                {{ $t('general.every') }}
                                <input v-model="remind_before_ending_every_y_days" class="d-inline" max="365" min="1"
                                  name="notification2_day2" style="width:65px;height:35px;" type="number" value="1"> {{ $t('general.every_n_days_send_message') }}
                              </p>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="can_be_added_to_calendar">{{ $t('general.add_to_calendar') }}</label>
                            <div class="col-md-6 text-right">
                              <label class="uk-switch" for="can_be_added_to_calendar">
                                <input id="can_be_added_to_calendar" v-model="can_be_added_to_calendar" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>
                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="has_customized_template">{{
                              $t('general.customize-email-template') }}</label>
                            <div class="col-md-6 text-right">
                              <label class="uk-switch" for="has_customized_template">
                                <input id="has_customized_template" v-model="has_customized_template" type="checkbox" />
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="row">
                            <div v-if="has_customized_template" class="col-12 form-group">
                              <label for="mail_subject">{{ $t("general.heading") }}</label>
                              <input id="mail_subject" v-model="mail_template.subject" class="uk-input" type="text"
                                maxlength="255" :placeholder="$t('general.heading')" />
                            </div>
                            <div v-if="has_customized_template" class="col-6">
                              <button id="uk_button_mail_codes" class="
                                              btn btn-secondary
                                              uk-button uk-button-default
                                              mb-3
                                            " type="button">
                                <i class="uil-plus-circle"></i> {{ $t("mail.add_code") }}
                              </button>
                            </div>

                            <div class="uk-width-large" uk-dropdown="toggle:#uk_button_mail_codes">
                              <div class="uk-dropdown-grid uk-child-width-1-2@m" uk-grid>
                                <div>
                                  <ul class="uk-nav uk-dropdown-nav">

                                    <template v-for="(code, i) in mail_template_codes">
                                      <template v-if="i < codeSlice()">
                                        <li class="uk-active">
                                          <a href="#">{{
                                            $t(code.key_name)
                                          }}</a>
                                        </li>
                                        <li>
                                          <b>{{ code.code }}</b>
                                          <a href="#" @click="copyCode(code.code)"><i class="uil-copy-alt"></i>
                                            {{ $t("general.copy") }}</a>
                                        </li>
                                        <li class="uk-nav-divider"></li>
                                      </template>
                                    </template>
                                  </ul>
                                </div>
                                <div>
                                  <ul class="uk-nav uk-dropdown-nav">

                                    <template v-for="(code, i) in mail_template_codes">
                                      <template v-if="i >= codeSlice()">
                                        <li class="uk-active">
                                          <a href="#">{{ code.name }}</a>
                                        </li>
                                        <li>
                                          <b>{{ code.code }}</b>
                                          <a href="#" @click="copyCode(code.code)"><i class="uil-copy-alt"></i>
                                            {{ $t("general.copy") }}</a>
                                        </li>
                                        <li class="uk-nav-divider"></li>
                                      </template>
                                    </template>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <html-area v-if="mail_template.html != undefined &&
                              has_customized_template
                              " :company="company" :model="mail_template" @update="updateMailTemplate"></html-area>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="uk-card-footer float-right pb-0 pr-0 pr-0">
                    <button class="uk-button uk-button-outline small mr-2" type="submit"
                      @click="switcherChange($isGiftVisible ? 3 : 2)">
                      <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                    </button>
                    <button class="uk-button uk-button-primary small" type="submit"
                      @click="validateAndSwitch($isGiftVisible ? 5 : 4)">
                      <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                    </button>
                  </div>
                </div>
              </li>
              <!--tab: sonuç-->
              <li>
                <div class="row">
                  <div class="col-12 my-lg-5">
                    <div class="text-center">
                      <h2 class="mt-0">
                        <i class="icon-feather-check-circle text-success"></i>
                      </h2>
                      <h3 class="mt-0">{{ $t('general.assignment_ready') }}!</h3>

                      <div class="col-md-6 offset-md-3">
                        <table class="uk-table uk-table-divider result-table">
                          <tbody>
                            <tr>
                              <td class="text-center" colspan="2">
                                <img alt="" class="logoarea rounded img-fluid" src="@/assets/images/no-photo.png" />
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ $t('general.assignment_name') }}:</td>
                              <td class="text-left">
                                <b>{{ name }}</b>
                              </td>
                            </tr>
                            <!-- <tr>
                    <td class="text-right">{{ $t('general.training_name') }}:</td>
                    <td class="text-left">
                      <b>İş Sağlığı ve Güvenliği</b>
                    </td>
                  </tr> -->
                            <tr v-if="checked_users.length > 0">
                              <td class="text-right">
                                {{ $t('general.number_of_assigned_users') }}:
                              </td>
                              <td class="text-left">
                                <b>{{ checked_users.length }}</b>
                              </td>
                            </tr>
                            <tr v-if="checked_groups.length > 0">
                              <td class="text-right">{{ $t('general.assigned_group_count') }}:</td>
                              <td class="text-left">
                                <b>{{ checked_groups.length }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ $t('general.give_a_gift_at_the_end') }}:</td>
                              <td class="text-left">
                                <b>{{
                                  has_present
                                  ? $t("general.yes")
                                  : $t("general.no")
                                }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">
                                {{ $t('general.top_rankings_list_display') }}:
                              </td>
                              <td class="text-left">
                                <b>{{
                                  appear_top
                                  ? $t("general.yes")
                                  : $t("general.no")
                                }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ $t('general.start_day') }}:</td>
                              <td class="text-left">
                                <b>{{ start_date }}</b>
                              </td>
                            </tr>
                            <tr>
                              <td class="text-right">{{ $t('general.final_completion_date') }}:</td>
                              <td class="text-left">
                                <b>{{ end_date }}</b>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>

                      <p class="w-75 mb-2 mx-auto" style="font-size: 0.875rem">
                        {{ $t('general.save-assignment-info') }}
                      </p>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <div class="uk-card-footer float-right pb-0 pr-0 mb-3">
                  <button class="uk-button uk-button-outline small mr-2" type="button"
                    @click="switcherChange($isGiftVisible ? 4 : 3)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small" type="button" @click="saveForm">
                    <i class="icon-feather-arrow-right"></i> {{ $t("general.save") }}

                  </button>
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>

    <modal :adaptive="false" :clickToClose="true" height="auto" name="qr_code_for_classroom_education" width="80%"
      @before-close="handleModalClose">
      <div class="uk-modal-body"
        style="max-height: 80vh; max-width: 95vw; overflow-y: auto; padding: 20px; box-sizing: border-box;">
        <div class="qr-grid">
          <div v-for="(item, qrIndex) in qr_text_array" :key="qrIndex" class="qr-card">
            <div class="qr-card-header">
              <h4 class="qr-card-title">{{ item.title }}</h4>
            </div>
            <div class="qr-card-body">
              <QrCodeStyled :data="item.code" :download-file-name="item.title || 'qr-code'" :download-size="1000"
                :margin="10" :show-download="true" :size="160" background-color="#ffffff" corners-dot-color="#0c4a6e"
                corners-dot-type="dot" corners-square-color="#0c4a6e" corners-square-type="extra-rounded"
                dots-color="#1e3a5f" dots-type="rounded" error-correction-level="H" />
            </div>
          </div>
        </div>
      </div>
    </modal>

    <div id="modal_customize" class="uk-flex-center" style="z-index: 9999999;" uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical">
        <div class="row" style="margin-top:1rem;margin-bottom: 1rem;margin-right: 1rem;">
          <div class="col-md-3" style="padding-left: 20px;">
            <ul class="uk-tab-right uk-tab sidemenu"
              uk-switcher="connect: #contentSetting ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
              <li class="uk-active">
                <a href="#"><i class="uil-keyboard"></i>
                  <b>{{ $t('general.content_settings') }}</b></a>
              </li>
            </ul>
          </div>
          <div class="col-md-9">
            <ul id="contentSetting" class="uk-switcher">
              <li class="uk-active">
                <div class="row">
                  <div class="col-md-12" style="padding:0">
                    <label class="uk-form-label">
                      {{ $t('general.content_feature') }}
                    </label>
                    <select v-model="selectedContentFeature" class="form-control">
                      <option v-for="contentFeature in content_features" :value="contentFeature.type">
                        {{ $t(contentFeature.name) }}
                      </option>
                    </select>
                  </div>

                  <template v-if="selectedContentFeature === 'timed_content'">
                    <div class="row">
                      <div class="col-md-12">
                        <label class="col-form-label" for="pass">
                          {{ $t('general.start_date') }}
                          <span class="required">*</span>
                        </label>
                        <VueCtkDateTimePicker v-model="contentsTimed[selectedEducationId].starts_at"
                          :format="'YYYY-MM-DD HH:mm:ss'" :max-date="contentsTimed[selectedEducationId].ends_at"
                          :min-date="setMinimumDate()" />
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="selectedContentFeature === 'timed_content'" class="row">
                  <div class="row">
                    <div class="col-md-12">
                      <label class="col-form-label" for="pass">
                        {{ $t('general.end_date') }}
                        <span class="required">*</span>
                      </label>
                      <VueCtkDateTimePicker v-model="contentsTimed[selectedEducationId].ends_at"
                        :format="'YYYY-MM-DD HH:mm:ss'" :min-date="contentsTimed[selectedEducationId].starts_at"
                        :no-button-now="true" />
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-if="selectedContentFeature === 'timed_content'" class="row" style="float:right">
              <button class="uk-button uk-button-outline small mr-2" type="button">
                <i class="icon-feather-arrow-left"></i>{{ $t('general.give_up') }}
              </button>
              <button :disabled="!controlContentRequired" class="uk-button uk-button-primary small" type="button"
                @click="saveContentFeatures()">
                <i class="icon-feather-arrow-right"></i> {{ $t('general.save') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import draggable from "vuedraggable";
import store from "@/core/services";
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection";
import Content from "@//view/components/assignment/Content";
import Gift from "@//view/components/assignment/Gift";
import HtmlArea from "@/view/company/Mail/Html";
import Multiselect from "vue-multiselect";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import QrCodeStyled from "@/view/components/ui/QrCodeStyled";
import axios from "axios";
import assignment_module, {
  BASE_URL as ASSIGNMENT_BASE_URL,
  CREATE_ITEM as ASSIGNMENT_CREATE_ITEM,
  ERROR as ASSIGNMENT_ERROR,
  ITEM as ASSIGNMENT_ITEM,
  MODULE_NAME as ASSIGNMENT_MODULE_NAME,
} from "@/core/services/store/assignment.module";

import survey_module, {
  BASE_URL as SURVEY_BASE_URL,
  GET_ITEMS as SURVEY_GET_ITEMS,
  ITEMS as SURVEY_ITEMS,
  MODULE_NAME as SURVEY_MODULE_NAME,
} from "@/core/services/store/evaluation_survey.module";

import { GET_ITEM_DETAIL_BY_ID, GET_ITEMS } from "@/core/services/store/REST.module";
import { createQrCodeForEveryClassroomEducation } from "@/view/company/Assignments/helpers/qrCodeHelper";
import { convertLocalToUTC } from "@/utils/timeUtils";
import contentModule, {
  BASE_URL as CONTENT_BASE_URL,
  GET_ITEM,
  MODULE_NAME as CONTENT_MODULE_NAME
} from "@/core/services/store/content.module";

import certificate_module, {
  BASE_URL as CERTIFICATE_BASE_URL,
  GET_ITEMS as CERTIFICATE_GET_ITEMS,
  ITEMS as CERTIFICATE_ITEMS,
  MODULE_NAME as CERTIFICATE_MODULE_NAME,
} from "@/core/services/store/certificate.module";

import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import CompetenciesInputSelection from "@/view/components/input/CompetenciesInputSelection.vue";
import DateRangePicker from "@/view/components/ui/DateRangePicker.vue";
import AiCoverImageGenerator from "@/view/components/ai-cover-image/AiCoverImageGenerator.vue";
import instructorService, {
  normalizeInstructor,
} from "@/core/services/instructor.service";

const _SURVEY_MODULE = SURVEY_MODULE_NAME;
const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE_NAME;
const _CONTENT_MODULE_NAME = CONTENT_MODULE_NAME;
const _CERTIFICATE_MODULE = CERTIFICATE_MODULE_NAME;

export default {
  name: "AddAssignment",
  components: {
    CompetenciesInputSelection,
    AppMultiselect,
    UserGroupSelection,
    draggable,
    Content,
    Gift,
    Multiselect,
    HtmlArea,
    DefaultLoading,
    QrCodeStyled,
    DateRangePicker,
    AiCoverImageGenerator,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_SURVEY_MODULE, survey_module);
    registerStoreModule(_ASSIGNMENT_MODULE, assignment_module);
    registerStoreModule(_CONTENT_MODULE_NAME, contentModule);
    registerStoreModule(_CERTIFICATE_MODULE, certificate_module);
  },
  data() {
    return {
      notification_send_type: 'now',
      notification_scheduled_at: null,
      selectedContentFeature: 'untimed_content',
      content_features: [{
        name: 'general.timed_content', type: 'timed_content', starts_at: 'null', ends_at: 'null'
      }, {
        name: 'general.untimed_content', type: 'untimed_content'
      }],
      contentsTimed: [],
      selectedEducationId: null,
      lastEndDate: null,
      lastStartDate: null,
      can_open_contents_in_order: true,
      qor_code_modal_title: this.$t("general.classroom_education_qr_code"),
      isClassRoomEducationSelected: false,
      durationFeatureIsEnabled: false,
      showModalLearning: false,
      restUrl: "api/mail-template/assignment",
      textarea_length: 0,
      successMessage: null,
      errorMessages: [],
      cover_image: null,
      cover_image_url: null,
      checked_users: [],
      checked_groups: [],
      name: null,
      is_compulsory: false,
      start_date: null,
      end_date: null,
      repeatable: false,
      repetition_no: 0,
      following_assignment_id: null,
      assignmentsList: [],
      assign_after_days: null,
      showCustomDayInput: false,
      customDays: null,
      duration: 0,
      survey_id: null,
      appear_top: false,
      survey_required: true,
      highlight_education: false,
      has_feedbacks: false,
      description: null,
      gift_rule_id: 1,
      has_present: 0,
      active_content_id: null,
      gifts: [],
      educations: [],
      repetition_date: [],
      has_customized_template: false,
      send_mail_notification: false,
      send_mobile_notification: false,
      can_be_added_to_calendar: false,
      can_be_watched_again: false,
      mail_template: [],
      mail_template_codes: [],
      company: [],
      all_selected_educations: [],
      all_selected_gifts: [],
      selected_content: null,
      assignment_loading: false,
      remind_if_not_entered_x_days: 1,
      remind_if_not_entered_every_y_days: 1,
      remind_before_starting_x_days: 1,
      remind_before_starting_every_y_days: 1,
      remind_before_ending_x_days: 1,
      remind_before_ending_every_y_days: 1,
      isRemindEntered: false,
      isRemindStarting: false,
      isRemindEnding: false,
      qr_text_array: [],
      certificate: {},
      selectedCompetencies: [],
      selectedWidgets: [],
      widgetItems: [],
      instructorOptions: [],
      selectedInstructors: [],
      instructorsLoading: false,
      is_competency_selected: false,
      mandatory_completion: false
    };
  },
  computed: {
    certificate_items: {
      get() {
        return store.getters[CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_ITEMS];
      },
      set(value) {
      },
    },
    controlContentRequired() {
      if (!this.contentsTimed[this.selectedEducationId].starts_at || !this.contentsTimed[this.selectedEducationId].ends_at)
        return false
      return true
    },
    assignment_item: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ITEM];
      },
      set(value) {
      },
    },
    survey_items: {
      get() {
        return store.getters[SURVEY_MODULE_NAME + "/" + SURVEY_ITEMS];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ERROR];
      },
      set(value) {
      },
    },
  },
  methods: {
    getCompetencyTooltip(competencies) {
      if (!competencies || competencies.length === 0) {
        return '';
      }

      let tooltipText = '';
      competencies.forEach((competency, index) => {
        tooltipText += `• ${competency.name}`;
        if (index < competencies.length - 1) {
          tooltipText += '<br>';
        }
      });

      return `title: ${tooltipText}`;
    },
    getImageUrl() {
      if (this.cover_image_url) {
        return this.cover_image_url;
      }

      if (this.cover_image && typeof this.cover_image === 'string') {
        return this.cover_image
      }

      return require('@/assets/images/no-photo.png');
    },
    processFile(event) {
      if (!event.target.files[0]) return;
      this.cover_image = event.target.files[0];
      this.cover_image_url = URL.createObjectURL(this.cover_image);
    },
    handleAiCoverImageSelected({ file, previewUrl }) {
      this.cover_image = file;
      this.cover_image_url = previewUrl;
    },
    setMinMaxTime() {
      if (!this.lastEndDate) {
        this.lastEndDate = new Date();
      }
      if (!this.lastStartDate) {
        this.lastStartDate = new Date();
      }
      this.contentsTimed.forEach((content) => {
        if (this.lastEndDate.getTime() < new Date(content.ends_at).getTime()) {
          this.lastEndDate = new Date(content.ends_at);
        }
        if (this.lastStartDate.getTime() > new Date(content.starts_at).getTime())
          this.lastStartDate = new Date(content.starts_at);
      })
    },
    saveContentFeatures() {
      if (this.selectedContentFeature === 'timed_content') {
        this.setMinMaxTime();
      }
      this.contentsTimed[this.selectedEducationId].type = this.selectedContentFeature;
      this.selectedContentFeature === 'untimed_content';
      UIkit.modal("#modal_customize").hide();
    },
    showCustomize(id, index) {
      this.selectedEducationId = index;
      if (!this.contentsTimed[index]) {
        this.contentsTimed.push({
          id: id,
          type: 'untimed_content',
          starts_at: null,
          ends_at: null
        });
      } else {
        this.selectedContentFeature = this.contentsTimed[index].type
      }
      UIkit.modal("#modal_customize").show();
    },
    hideSomeInputsForClassRoomEducation: function () {
      // @todo: move central place
      this.isClassRoomEducationSelected = false;

      let isClassRoomEducationSelected = false;
      let repeatable = false;

      const containsAnyClassRoomEducation = this.educations.some(
        (education) => education.name === this.$t("documents.classroom_education")
      );
      if (containsAnyClassRoomEducation) {
        isClassRoomEducationSelected = true;
        repeatable = false;
      }

      this.repeatable = repeatable;
      this.isClassRoomEducationSelected = isClassRoomEducationSelected;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode === 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getMailTemplateData() {
      let self = this;
      self.$store
        .dispatch(GET_ITEM_DETAIL_BY_ID, {
          url: self.restUrl,
          acceptPromise: false,
        })
        .then((result) => {
          if (typeof result !== 'undefined' && result.status) {
            self.company = result.data.company;
            self.mail_template = result.data.template;
            self.mail_template_codes = result.data.codes;
          }
        });
    },
    async getInstructorOptions() {
      this.instructorsLoading = true;
      try {
        const activeInstructors =
          await instructorService.listActiveInstructorOptions();
        const activeInstructorIds = new Set(
          activeInstructors.map((instructor) => instructor.id)
        );
        const selectedInstructorsNotInOptions = this.selectedInstructors.filter(
          (instructor) => !activeInstructorIds.has(instructor.id)
        );

        this.instructorOptions = [
          ...activeInstructors,
          ...selectedInstructorsNotInOptions,
        ];
      } catch (error) {
        this.instructorOptions = [];
        this.errorMessages.push(
          this.$t("general.instructor_list_load_failed")
        );
      } finally {
        this.instructorsLoading = false;
      }
    },
    saveForm() {
      this.assignment_loading = true;
      let self = this;
      if (!this.isValidFields("ALL")) {
        this.assignment_loading = false;
        return;
      }

      let formData = new FormData();
      if (this.contentsTimed?.length > 0) {
        for (let i = 0; i < this.contentsTimed?.length; i++) {
          formData.append("contents[" + i + "][id]",
            this.contentsTimed[i].id)

          formData.append("contents[" + i + "][starts_at]",
            convertLocalToUTC(this.contentsTimed[i].starts_at))
          formData.append("contents[" + i + "][ends_at]",
            convertLocalToUTC(this.contentsTimed[i].ends_at))
          formData.append("contents[" + i + "][type]",
            this.contentsTimed[i].type);
        }
      } else {
        self.educations.forEach((element, index) => {
          formData.append("contents[" + index + "]", element.id);
        });
      }

      formData.append("name", self.name);
      formData.append("description", self.description);
      const instructorIds = self.selectedInstructors
        .map((instructor) => Number(instructor.id))
        .filter(Number.isFinite);
      if (instructorIds.length) {
        instructorIds.forEach((id) => {
          formData.append("instructor_ids[]", id);
        });
      }
      formData.append("has_present", self.has_present === true ? 1 : 0);
      formData.append("gift_rule_id", self.gift_rule_id);
      formData.append("is_user", self.checked_users.length > 0 ? 1 : 0);
      formData.append("users", self.checked_users);
      formData.append("is_group", self.checked_groups.length > 0 ? 1 : 0);
      formData.append("dates[" + 0 + "][start_date]", convertLocalToUTC(self.start_date));
      formData.append("dates[" + 0 + "][end_date]", convertLocalToUTC(self.end_date));
      formData.append("is_compulsory", self.is_compulsory ? 1 : 0);
      formData.append("certificate_id", self.certificate?.id || null);
      if (this.notification_send_type === 'scheduled' && this.notification_scheduled_at) {
        formData.append("notification_scheduled_at", convertLocalToUTC(this.notification_scheduled_at));
      }

      formData.append(
        "highlight_education",
        self.highlight_education === true ? 1 : 0
      );
      formData.append(
        "can_open_contents_in_order",
        self.can_open_contents_in_order
      );
      formData.append("repeatable", self.repeatable === true ? 1 : 0);
      formData.append(
        "repetition_no",
        self.repeatable ? self.repetition_no : 0
      );
      formData.append("duration", self.duration);
      formData.append("survey_required", self.survey_required ? 1 : 0);
      formData.append(
        "send_mail_notification",
        self.send_mail_notification === true ? 1 : 0
      );
      formData.append(
        "send_mobile_notification",
        self.send_mobile_notification === true ? 1 : 0
      );
      formData.append(
        "can_be_added_to_calendar",
        self.can_be_added_to_calendar === true ? 1 : 0
      );
      formData.append(
        "can_be_watched_again",
        self.can_be_watched_again === true ? 1 : 0
      );
      formData.append(
        "has_customized_template",
        self.has_customized_template === true ? 1 : 0
      );
      formData.append("appear_top", self.appear_top === true ? 1 : 0);
      formData.append("has_feedbacks", self.has_feedbacks === true ? 1 : 0);
      formData.append("mandatory_completion", self.mandatory_completion === true ? 1 : 0);
      formData.append("cover_image", self.cover_image);

      if (self.following_assignment_id) {
        formData.append("followup_assignment_id", self.following_assignment_id.id);

        let daysToSend = null;
        if (self.showCustomDayInput && self.customDays) {
          daysToSend = self.customDays;
        } else if (self.assign_after_days && typeof self.assign_after_days === 'object') {
          daysToSend = self.assign_after_days.value;
        }

        if (daysToSend && daysToSend !== 'custom') {
          formData.append("assign_after_days", daysToSend);
        }
      } else {
        formData.append("followup_assignment_id", null);
        formData.append("assign_after_days", null);
      }

      if (this.is_competency_selected) {
        this.selectedCompetencies.forEach((item) => formData.append("competencies[]", item.id));
      }

      this.selectedWidgets.forEach((item) => formData.append("widgets[]", item.id));

      if (self.has_customized_template === true) {
        formData.append("mail_template", self.mail_template.html);
        formData.append(
          "mail_subject",
          typeof self.mail_template.subject === "string"
            ? self.mail_template.subject.trim()
            : ""
        );
      }

      if (self.survey_required === true) {
        formData.append("evaluation_survey_id", self.survey_id.id);
      }

      if (self.repeatable) {
        for (let i = 1; i <= self.repetition_no; i++) {
          if (
            self.repetition_date[i].start_date >
            self.repetition_date[i].end_date
          ) {
            this.errorMessages.push(
              this.$t("general.start_date_must_be_before_end")
            );
            return false;
          }
          formData.append(
            "dates[" + i + "][start_date]",
            convertLocalToUTC(self.repetition_date[i].start_date)
          );
          formData.append(
            "dates[" + i + "][end_date]",
            convertLocalToUTC(self.repetition_date[i].end_date)
          );
        }
      }
      self.gifts.forEach((element) => {
        formData.append("gifts[]", element.id);
      });
      self.checked_groups.forEach((element) => {
        formData.append("groups[]", element);
      });
      if (this.isRemindEntered) {
        formData.append("remind_if_not_entered_x_days", self.remind_if_not_entered_x_days);
        formData.append("remind_if_not_entered_every_y_days", self.remind_if_not_entered_every_y_days);
      }
      if (this.isRemindStarting) {
        formData.append("remind_before_starting_x_days", self.remind_before_starting_x_days);
        formData.append("remind_before_starting_every_y_days", self.remind_before_starting_every_y_days);
      }
      if (this.isRemindEnding) {
        formData.append("remind_before_ending_x_days", self.remind_before_ending_x_days);
        formData.append("remind_before_ending_every_y_days", self.remind_before_ending_every_y_days);
      }

      store
        .dispatch(ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_CREATE_ITEM, {
          url: ASSIGNMENT_BASE_URL,
          contents: formData,
        })
        .then((result) => {
          self.assignment_loading = false;
          self.scrollToTop();

          if (this.error) {
            this.errorMessages.push(this.error);
          }

          this.qr_text_array = createQrCodeForEveryClassroomEducation({
            result,
            assignmentId: this.assignment_item.id
          })

          if (this.qr_text_array?.length) {
            this.successMessage = self.$t("general.successfully_created");
            this.$modal.show("qr_code_for_classroom_education");
          } else {
            this.handleModalClose()
          }

        });
    },
    handleModalClose() {
      this.$router.push({ name: "company.assignments.list" });
    },
    updateMailTemplate(newCode) {
      if (
        this.mail_template.is_linked &&
        (!newCode.includes("{SLINK}") || !newCode.includes("<!--BUTTON-->"))
      ) {
        this.errorMessages.push(
          this.$t("validation.required_field").replace(":NAME", "{SLINK}")
        );
        return false;
      }
      this.mail_template.html = newCode;
    },
    codeSlice() {
      if (this.mail_template_codes.length === undefined) return 0;
      return Math.ceil(this.mail_template_codes.length / 2);
    },
    copyCode(code) {
      const el = document.createElement("textarea");
      el.value = code;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    async addContentToAssignment(item) {
      let edu_id = item.id;

      // Prevent adding the same item twice
      if (this.all_selected_educations.includes(edu_id)) return false;

      // Detect if item is a program
      const isProgram = item.name === "documents.program";

      // Add file_category_id based on item type
      const preparedItem = {
        ...item,
        file_category_id: isProgram ? 11 : 1
      };

      // 1) SINGLE CONTENT: Check conflict with existing program
      if (!isProgram) {
        const existingProgram = this.educations.find(e => e.name === "documents.program");
        if (existingProgram) {
          const tempItems = [
            { id: existingProgram.id, file_category_id: 11 },
            { id: preparedItem.id, file_category_id: 1 }
          ];
          try {
            await axios.post('/api/assignment/unique-content-validate', { items: tempItems });
          } catch (err) {
            if (err.response?.status === 422) {
              UIkit.notification({
                message: this.$t('general.same_content_in_program'),
                status: 'danger',
                pos: 'top-center',
                timeout: 4000
              });
              return false;
            }
          }
        }

        // No conflict → add single content
        this.hideSomeInputsForClassRoomEducation();
        this.educations.push(preparedItem);
        this.all_selected_educations.push(edu_id);
        return true;
      }

      // 2) PROGRAM: Validate with all existing items
      const tempItems = this.educations.concat(preparedItem).map(x => ({
        id: x.id,
        file_category_id: x.file_category_id ?? (x.name === "documents.program" ? 11 : 1)
      }));

      try {
        await axios.post('/api/assignment/unique-content-validate', { items: tempItems });

        // No conflict → add program
        this.hideSomeInputsForClassRoomEducation();
        this.educations.push(preparedItem);
        this.all_selected_educations.push(edu_id);

      } catch (err) {
        if (err.response?.status === 422) {
          UIkit.notification({
            message: this.$t('general.same_content_in_program'),
            status: 'danger',
            pos: 'top-center',
            timeout: 4000
          });
          return false;
        }

        UIkit.notification({
          message: this.$t('general.program_add_validation_error'),
          status: 'danger',
          pos: 'top-center',
          timeout: 4000
        });
        return false;
      }
    },
    addGiftToAssignment(item) {
      let gift_id = item.id;
      this.all_selected_gifts.push(gift_id);
      this.gifts.push(item);
    },
    removeGiftFromAssignment(id) {
      let gifts = this.gifts;
      let gifts_ids_all = this.all_selected_gifts;
      let pos = gifts
        .map(function (x) {
          return x;
        })
        .indexOf(id);
      let pos_all = gifts_ids_all
        .map(function (x) {
          return x;
        })
        .indexOf(id);
      gifts.splice(pos, 1);
      gifts_ids_all.splice(pos_all, 1);
      return true;
    },
    removeContentFromAssignment(education, index) {
      const edu_id = education.id;

      let educations = this.educations;
      let educations_ids_all = this.all_selected_educations;

      let pos_all = educations_ids_all.map((x) => x).indexOf(edu_id);

      let edu_pos = educations.map((x) => x.id).indexOf(edu_id);

      educations.splice(edu_pos, 1);
      educations_ids_all.splice(pos_all, 1);
      this.contentsTimed.splice(index, 1)
      this.hideSomeInputsForClassRoomEducation();
      return true;
    },
    async getSurveys() {
      let self = this;
      await this.$store.dispatch(SURVEY_MODULE_NAME + "/" + SURVEY_GET_ITEMS, {
        url: SURVEY_BASE_URL,
        filters: {
          is_active: 1,
          order: "asc",
          sort: "id",
          fields: "id,name,is_default",
        },
      });

      let survey = this.survey_items.find(
        (item) => parseInt(item.is_default) === 1
      );
      if (typeof survey !== "undefined") {
        self.survey_id = {
          id: survey.id,
          name: survey.name,
        };
      }
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getResultsAll() {
      this.getMailTemplateData();
      this.getSurveys();
    },
    inputClick() {
      $("#cover_photo_input").click();
    },
    isValidFields(fields) {
      let self = this;

      self.resetMessages();

      if (fields !== "ALL") {
        fields--;
      }

      const indexOfEntryTab = 0;
      const indexOfContentTab = 1;
      const indexOfUsersTab = 2;
      const indexOfGiftTab = 3;

      if (fields === "ALL" || fields === indexOfEntryTab) {
        if (self.name == null || self.name?.length === 0) {
          return self.showFieldsFailedError(
            indexOfEntryTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.assignment_name'))
          );
        }

        if (self.description === null || self.description?.length === 0) {
          return self.showFieldsFailedError(
            indexOfEntryTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.description'))
          );
        }

        if (self.cover_image === null) {
          return self.showFieldsFailedError(
            indexOfEntryTab,
            self.$t("content.required.cover_photo")
          );
        }
      }

      if ((fields === "ALL" || fields === indexOfContentTab) && self.all_selected_educations.length === 0) {
        return self.showFieldsFailedError(
          indexOfContentTab,
          self.$t("validation.required_field").replace(":NAME", self.$t('messages.content'))
        );
      }

      if ((fields === "ALL" || fields === indexOfUsersTab) && self.checked_users.length === 0 && self.checked_groups.length === 0) {
        return self.showFieldsFailedError(
          indexOfUsersTab,
          self.$t("validation.required_field").replace(":NAME", self.$t('users.users'))
        );
      }

      if (this.$isGiftVisible && (fields === "ALL" || fields === indexOfGiftTab) && self.has_present && self.all_selected_gifts.length === 0) {
        return self.showFieldsFailedError(
          indexOfGiftTab,
          self.$t("validation.required_field").replace(":NAME", self.$t('general.gift'))
        );
      }

      let indexOfSettingsTab = this.$isGiftVisible && fields === 3 ? 5 : 4;

      if (fields === "ALL" || fields === indexOfSettingsTab) {
        if (self.start_date == null) {
          return self.showFieldsFailedError(
            indexOfSettingsTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.start_day'))
          );
        }

        if (self.end_date == null) {
          return self.showFieldsFailedError(
            indexOfSettingsTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.final_completion_date'))
          );
        }

        if (self.duration === "" || self.duration < 0) {
          self.duration = 0;
        }

        if (self.repeatable && self.repetition_no <= 0) {
          return self.showFieldsFailedError(
            indexOfSettingsTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.number_of_repetitions'))
          );
        }

        if (self.survey_required && (self.survey_id == null || !self.survey_id)) {
          return self.showFieldsFailedError(
            indexOfSettingsTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.the_survey'))
          );
        }

        if (self.has_customized_template && (self.mail_template.html == null || self.mail_template.html === "")) {
          return self.showFieldsFailedError(
            indexOfSettingsTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.the_email_template'))
          );
        }
        if (self.following_assignment_id) {
          let daysValue = null;
          if (self.showCustomDayInput) {
            daysValue = self.customDays;
          } else if (self.assign_after_days && typeof self.assign_after_days === 'object') {
            daysValue = self.assign_after_days.value;
          }

          if (!daysValue || daysValue === 'custom' || daysValue <= 0) {
            return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.assign-after-days'))
            );
          }
        }
      }

      return true;
    },
    showFieldsFailedError(index, message) {
      this.errorMessages.push(message);
      this.scrollToTop();
      this.switcherChange(index);

      return false;
    },
    validateAndSwitch(index) {
      let areAllFieldsValid = this.isValidFields(index);
      if (areAllFieldsValid) {
        this.switcherChange(index);
      }

      const indexNumberOfSettingsTab = 4;
      if (index === indexNumberOfSettingsTab) {
        this.hideSomeInputsForClassRoomEducation();
      }
    },
    switcherChange(index) {
      UIkit.switcher($("#main-switcher")[0]).show(index);
    },
    setMinimumDate(start_date = null) {
      let date = new Date();
      if (start_date) {
        let startDate = new Date(start_date);
        date = new Date(startDate.getTime() + 86400000); // + 1 day in ms
      }
      return date.toISOString().split("T")[0];
    },
    async getItemInUrlDetail() {
      const { id: contentId, name: contentName, title: contentTitle } = this.$route.params
      let fetchedContent = null;

      if (contentId) {
        // içerikler sayfasından içeriklere tıklandığında params degeri olarak id-name-title değerleri geliyor

        try {
          fetchedContent = await store.dispatch(CONTENT_MODULE_NAME + "/" + GET_ITEM, {
            url: CONTENT_BASE_URL + "/" + contentId,
          });

          const contentData = fetchedContent.data || fetchedContent;

          this.name = contentData.title || "";
          this.description = contentData.description || "";
          this.cover_image = contentData.cover_photo || null;
          this.selectedInstructors = Array.isArray(contentData.instructors)
            ? contentData.instructors.map(normalizeInstructor)
            : [];

          this.selected_content = {
            id: contentId,
            title: contentData.title || "",
            name: contentData.file_category?.name || "",
            competencies: contentData.competencies || []
          };

          if (this.selected_content) {
            this.addContentToAssignment(this.selected_content);
          }
        } catch (error) {
          console.error("İçerik verisi alınamadı:", error);
        }
      }

    },
    getWidgets() {
      axios.get('/api/widgets/assignment/list').then((response) => {
        const locale = this.$i18n.locale;
        this.widgetItems = response.data.map((item) => ({
          ...item,
          title: item.lang_title && item.lang_title[locale] ? item.lang_title[locale] : item.title
        }));
      });
    },
    getCertificates() {
      this.$store.dispatch(
        CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_GET_ITEMS,
        {
          url: CERTIFICATE_BASE_URL,
          filters: {
            status_id: 1,
            order: "asc",
            sort: "id",
          },
        }
      );
    },
    async getAssignments() {
      try {
        const response = await this.$store.dispatch(GET_ITEMS, {
          url: 'api/assignment',
          filters: {
            search: '',
            sort: 'desc',
            order_by: 'created_at',
            status_id: 1,
            by_user: false,
          },
        });

        if (response && response.data) {
          this.assignmentsList = response.data.map(assignment => ({
            id: assignment.id,
            name: assignment.name,
          }));
        }
      } catch (error) {
        this.assignmentsList = [];
      }
    },
  },
  async mounted() {
    this.getResultsAll();

    if (!this.$isGiftVisible) {
      this.has_present = 0;
    }
    setTimeout(() => {
      $(".selectpicker7").selectpicker();
    }, 400);

    this.$forceUpdate();

    setTimeout(() => {
      this.showModalLearning = true;
    }, 1000);

    try {
      await this.getItemInUrlDetail()
    } catch (error) {
      console.error("getItemInUrlDetail hatası:", error);
    }

    this.getCertificates();
    this.getAssignments();
    this.getWidgets();
    this.getInstructorOptions();

  },
  watch: {
    assignment_loading(val) {

    },
    description(val) {
      this.textarea_length = val.length;
    },
    repetition_no(val) {
      let date = new Date();
      let end_date = new Date(date.getTime() + 86400000)
        .toISOString()
        .split("T")[0];
      let start_date = date.toISOString().split("T")[0];
      if (val) {
        for (let index = 1; index <= val; index++) {
          this.repetition_date[index] = {};
          this.repetition_date[index].start_date = start_date;
          this.repetition_date[index].end_date = end_date;
        }
      }
    },
    survey_items(value) {
      if (value && value.length)
        setTimeout(() => {
          $(".selectpicker_survey").selectpicker();
        }, 500);
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
    can_be_added_to_calendar(val) {
      val ? this.send_mail_notification = val : null;
      this.can_be_added_to_calendar = val;
    },
    send_mail_notification(val) {
      !val ? this.can_be_added_to_calendar = val : null;
      this.send_mail_notification = val;
    },
    send_mobile_notification(val) {
      this.send_mobile_notification = val;
    },
    following_assignment_id(newVal) {
      if (!newVal) {
        this.assign_after_days = null;
        this.showCustomDayInput = false;
        this.customDays = null;
      }
    },
    assign_after_days(newVal) {
      if (newVal && newVal.value === 'custom') {
        this.showCustomDayInput = true;
        this.customDays = null;
      } else if (newVal && typeof newVal === 'object' && newVal.value !== 'custom') {
        this.customDays = newVal.value;
      }
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 3000);
  },

  beforeDestroy() {
    const modal = UIkit.modal("#modal_learning");
    if (modal) modal.$destroy(true);

    const modalGift = UIkit.modal("#modal_gifts");
    if (modalGift) modalGift.$destroy(true);

    const modalCustomize = UIkit.modal("#modal_customize");
    if (modalCustomize) modalCustomize.$destroy(true);

    // ✅ Sayfadan çıkınca değeri sıfırla
    this.notification_scheduled_at = null;
  }
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-tab li.uk-active a {
  border-color: #eceff0;
}

.uk-tab-right::before {
  display: none;
}

.sidemenu li a {
  font-size: 13px;
  border-bottom: 1px solid #eaeaea;
}

.row_number {
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
}
</style>

<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

/* .header-a {
  cursor: default;
  pointer-events: none;
} */

/* QR modal: kartlar yan yana (Edit sayfası ile aynı) */
.qr-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  justify-content: center;
  max-width: 100%;
}

.qr-card {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 1.25rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 250px;
  box-sizing: border-box;
}

.qr-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(14, 165, 233, 0.15);
}

.qr-card-header {
  text-align: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
}

.qr-card-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
}

.qr-card-body {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
}

.datetimepicker {
  left: -120px !important;
}

.tooltip-wrap {
  position: relative;
  cursor: pointer;
  font-weight: 100 !important;
}

.tooltip-text {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 125%;
  left: 0;
  background: #333;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  transition: 0.2s;
  z-index: 9999;

  white-space: normal;
  width: 220px;
}

.tooltip-wrap:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
</style>
